import { InsumoProveedorEstado } from 'src/utils/enums/InsumoProveedorEstado';
import { InsumoProveedorFormState } from './types';
import { actualizarInsumoProveedorPrecio } from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';
import { colorMapping } from 'src/utils/enums/InsumoProveedorEstado';

const initialState: InsumoProveedorFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'insumoProveedorForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },
    setFormStatusBorrador(state) {
      state.status = {
        id: InsumoProveedorEstado.Borrador,
        text: InsumoProveedorEstado[
          InsumoProveedorEstado.Borrador
        ].toUpperCase(),
        color: colorMapping[InsumoProveedorEstado.Borrador],
      };
      state.data = {
        ultimaActualizacion: { readOnly: true, visible: false },
        ultimaCompra: { readOnly: true, visible: false },
        actualizadoAMano: { readOnly: true, visible: false },
        ultimoPrecioUnitario: { readOnly: false, visible: false },
        unidadDeCompraId: { readOnly: false },
        unidadDeConsumoId: { readOnly: true },
        codigoProveedor: { readOnly: false },
        presentacion: { readOnly: false },
        insumoCodigo: { readOnly: false },
        proveedorId: { readOnly: false },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        comprarInsumoProveedor: {
          visible: false,
          disabled: false,
          tooltip: 'Comprar insumo',
        },
        actualizarInsumoProveedorPrecio: {
          visible: false,
          disabled: true,
          tooltip: 'Actualizar precio del insumo',
        },
      };
    },
    setFormStatusActualizado(state) {
      state.status = {
        id: InsumoProveedorEstado.Actualizado,
        text: InsumoProveedorEstado[
          InsumoProveedorEstado.Actualizado
        ].toUpperCase(),
        color: colorMapping[InsumoProveedorEstado.Actualizado],
      };
      state.data = {
        ultimaActualizacion: { readOnly: true },
        ultimaCompra: { readOnly: true },
        actualizadoAMano: { readOnly: true },
        ultimoPrecioUnitario: { readOnly: false },
        unidadDeCompraId: { readOnly: false },
        unidadDeConsumoId: { readOnly: true },
        codigoProveedor: { readOnly: true },
        presentacion: { readOnly: false },
        insumoCodigo: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        comprarInsumoProveedor: {
          visible: true,
          disabled: false,
          tooltip: 'Comprar insumo',
        },
        actualizarInsumoProveedorPrecio: {
          visible: true,
          disabled: false,
          tooltip: 'Actualizar precio del insumo',
        },
      };
    },
    setFormStatusDesactualizado(state) {
      state.status = {
        id: InsumoProveedorEstado.Desactualizado,
        text: InsumoProveedorEstado[
          InsumoProveedorEstado.Desactualizado
        ].toUpperCase(),
        color: colorMapping[InsumoProveedorEstado.Desactualizado],
      };
      state.data = {
        ultimaActualizacion: { readOnly: true },
        ultimaCompra: { readOnly: true },
        actualizadoAMano: { readOnly: true },
        ultimoPrecioUnitario: { readOnly: false },
        codigoProveedor: { readOnly: true },
        presentacion: { readOnly: false },
        unidadDeCompraId: { readOnly: false },
        unidadDeConsumoId: { readOnly: true },
        insumoCodigo: { readOnly: true },
        proveedorId: { readOnly: true },
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        comprarInsumoProveedor: {
          visible: true,
          disabled: false,
          tooltip: 'Comprar insumo',
        },
        actualizarInsumoProveedorPrecio: {
          visible: true,
          disabled: false,
          tooltip: 'Actualizar precio del insumo',
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      actualizarInsumoProveedorPrecio.fulfilled,
      (state, action) => {
        console.log(
          'Completar con la lógica correspondiente a la acción exitosa.'
        );
      }
    );
    builder.addCase(
      actualizarInsumoProveedorPrecio.rejected,
      (state, action) => {
        console.log(
          'Completar con la lógica correspondiente a la acción fallida.'
        );
      }
    );
  },
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.insumoProveedor.form.status;

export const selectActualizarInsumoProveedorPrecio = (state: RootState) =>
  state.insumoProveedor.form.actions?.actualizarInsumoProveedorPrecio;

export const selectComprarInsumoProveedor = (state: RootState) =>
  state.insumoProveedor.form.actions?.comprarInsumoProveedor;

export const selectGuardar = (state: RootState) =>
  state.insumoProveedor.form.actions?.guardar;

// Export actions
export const {
  resetForm,
  setFormStatusBorrador,
  setFormStatusActualizado,
  setFormStatusDesactualizado,
} = formSlice.actions;

export default formSlice.reducer;
